import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import analytics from '../services/GoogleAnalytics';

export const useAnalytics = () => {
  const location = useLocation();
  const [cookies] = useCookies(['user', 'token', 'super_user']);

  useEffect(() => {
    const path = location.pathname + location.search;

    const getPageTitle = (): string => {
      const pathname = location.pathname;

      if (pathname === '/') return 'Dashboard - GritCargo';
      if (pathname === '/login') return 'Login - GritCargo';
      if (pathname === '/rtl') return 'RTL Devices - GritCargo';
      if (pathname === '/shipments') return 'Shipments - GritCargo';
      if (pathname === '/locations') return 'Locations - GritCargo';
      if (pathname === '/rtl-alerts' || pathname === '/device-alerts')
        return 'Device Alerts - GritCargo';
      if (pathname === '/users') return 'Users - GritCargo';
      if (pathname === '/support') return 'Support - GritCargo';
      if (pathname.includes('/admin')) return 'Admin Panel - GritCargo';
      if (pathname.includes('/rtl/')) return 'RTL Details - GritCargo';

      return document.title;
    };

    analytics.trackPageView(path, getPageTitle());
  }, [location]);

  useEffect(() => {
    if (cookies.user && cookies.token) {
      const isAdmin = cookies.super_user || false;
      const userRole = cookies.user.role || 'user';

      analytics.setUserProperties(
        cookies.user.id || cookies.user.email,
        userRole,
        isAdmin
      );
    } else {
      analytics.clearUserData();
    }
  }, [cookies.user, cookies.token, cookies.super_user]);

  return useMemo(
    () => ({
      trackPageView: analytics.trackPageView.bind(analytics),

      trackLogin: analytics.trackLogin.bind(analytics),
      trackLogout: analytics.trackLogout.bind(analytics),

      trackSearch: analytics.trackSearch.bind(analytics),

      trackRTLView: analytics.trackRTLView.bind(analytics),
      trackRTLWarning: analytics.trackRTLWarning.bind(analytics),
      trackRTLToleranceProfile:
        analytics.trackRTLToleranceProfile.bind(analytics),

      trackShipmentView: analytics.trackShipmentView.bind(analytics),

      trackLocationView: analytics.trackLocationView.bind(analytics),

      trackUserManagement: analytics.trackUserManagement.bind(analytics),

      trackAdminAction: analytics.trackAdminAction.bind(analytics),

      trackSupport: analytics.trackSupport.bind(analytics),

      trackDownload: analytics.trackDownload.bind(analytics),

      trackFormSubmission: analytics.trackFormSubmission.bind(analytics),

      trackError: analytics.trackError.bind(analytics),

      trackEvent: analytics.trackEvent.bind(analytics),
    }),
    []
  );
};
